<template>
  <div class="form-group"
    v-bind:class="{'has-error': errors.first(field.key)}">
    <p class="scroll-box-title" v-html="sanitizedAdditionalText"></p>
    <div @scroll="onScroll" class="form-scroll-box scroll-box-checkbox" v-html="sanitizedHelpText"></div>
    <div class="custom-control custom-checkbox">
      <small class="label" v-html="sanitizedFieldTitle"></small>
      <label class="form-item-group form-item-checkbox">
        <input type="checkbox"
          class="custom-control-input"
          v-bind:disabled=disabled
          v-on:change="$emit('input', $event.target.checked)"
          v-bind:name="field.key"
          v-bind:checked="value"
          v-validate="validationRules"
          v-bind:data-vv-as="strippedFieldTitle"
          tabindex="1">
        <span class="custom-control-label">
          {{ option.title }}
        </span>
        <small class="label" v-html="option.help_text"></small>
      </label>
      <span class="invalid-feedback"
        v-if="errors.has(field.key)">
        {{ errors.first(field.key) }}
      </span>
    </div>
  </div>
</template>

<script>
import InputMixin from '@/mixins/InputMixin';

/**
 * A field that renders a scroll box and a list of checkbox inputs.
 */
export default {
  name: 'ScrollBoxCheckbox',
  mixins: [
    InputMixin,
  ],
  props: {
    /**
     * The input value
     */
    value: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  data() {
    return {
      disabled: true,
    };
  },
  computed: {
    /**
     * Return the single option that the component uses.
     */
    option() {
      return this.field.options[0];
    },
  },
  methods: {
    onScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
      // When zoomed in Chrome, somehow scrollTop will have decimals, and make it 1px less.
      // scrollTop+clientHeight will become little less then scrollHeight.
      // add 5px to scrollTop + clientHeight, to make sure they are larger then scrollHeight
      if (scrollTop + clientHeight + 5 >= scrollHeight) {
        this.disabled = false;
      }
    },
  },
};
</script>
